import React from 'react';

export const MapError = ({ message }) => (
  <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 backdrop-blur-sm">
    <div className="text-red-500 text-center p-4">
      <p>Failed to load map</p>
      <p className="text-sm mt-2">{message}</p>
      <button
        onClick={() => window.location.reload()}
        className="mt-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
      >
        Refresh Page
      </button>
    </div>
  </div>
);

export default MapError;